export const inquiryList = [
  { name: '서비스 문의', value: '1' },
  { name: '기능 문의', value: '2' },
  { name: '장애 신고', value: '3' },
  { name: '제안 사항', value: '4' },
  { name: '웰뱅 연동', value: '5' },
  { name: '부정 걸음수', value: '6' },
  { name: '기타', value: '6' },
];
